/**
 * Browser storage keys shared between AICA sessionStorage and localStorage.
 * Centralized so callers (helpers, interceptors, integrations) cannot drift.
 */
export const STORAGE_KEYS = {
    AUTH_TOKEN: 'auth_token',
    ORG_ID: 'org_id',
    USER_ORG_ID: 'user_org_id',
    USER_ID: 'user_id',
    USER_DATA: 'user_data',
    ASK_AICA_ORB_SEEN_KEYS: 'askAicaOrbSeenKeys',
} as const;
